import { useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { getSlugifiedApi } from '../../utils/add-slugs-to-api'
import { StencilCDNImage } from '@/components/Common/StencilImage'
import Link from '@/components/Common/Link'
import { fetchRequest } from '@/root/utils/network-adapter/fetch-request'

interface IImageGridData {
  data?: {
    amcs_widget?: {
      data?: Array<{
        link?: string
        image?: string
        title: string
      }>
    }
  }
}

const ImageGridV0Widget = ({ apiUrl }: { apiUrl: string }) => {
  const [imageGridData, updateImageGridData] = useState<IImageGridData | null>()
  const { asPath } = useRouter()
  const slugs = asPath.split('/')

  const getFilterCall = async headers => {
    const resp = await fetchRequest({
      url: getSlugifiedApi(apiUrl, slugs),
      config: { headers },
    })
    return resp
  }

  const getFilterMutation = useMutation(getFilterCall)

  const updateFilter = () => {
    getFilterMutation.mutate(
      {},
      {
        onSuccess: resp => {
          if (resp) {
            updateImageGridData(resp)
          }
        },
      },
    )
  }

  useEffect(() => {
    updateFilter()
  }, [])

  return imageGridData?.data?.amcs_widget?.data?.length ? (
    <div>
      <div className="flex flex-row flex-wrap items-center justify-center gap-x-6 gap-y-4">
        {imageGridData.data.amcs_widget.data.map((opt, ind) => {
          return (
            <Link key={ind} href={opt.link ?? '/'}>
              <div
                className={classNames(
                  'flex min-h-[60px] min-w-[60px] ',
                  'hover:scale-110',
                )}
              >
                {opt.image && (
                  <StencilCDNImage
                    src={opt.image}
                    alt={opt.title}
                    height={60}
                    width={60}
                    className="rounded-full"
                  />
                )}
              </div>
            </Link>
          )
        })}
      </div>
      <div className="text-brand-grey-base mt-8 px-10 text-[11px] lg:mt-16">
        Logos above are the property of respective trademark owners and by
        displaying it INDmoney has no right, title, interest over it.
      </div>
    </div>
  ) : (
    <div />
  )
}

export default ImageGridV0Widget
